module.exports = __webpack_public_path__ + "static/media/item_6_12_comp.218db6da.png";